var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ConsentStatus, ConsentUpdate, ConsentUpdateFromUI, getIASConsentTypes, } from "healthex-common/consent.dtos";
import { observable } from "mobx";
export class IASManager {
    constructor(authManager, patientService) {
        this.authManager = authManager;
        this.patientService = patientService;
        this.submittingConsent = false;
    }
    async optInToIAS(consentingPatientInfo, input) {
        await this.updateIASConsent(consentingPatientInfo, ConsentStatus.OPTED_IN, input);
    }
    async optOutOfIAS(consentingPatientInfo, input) {
        await this.updateIASConsent(consentingPatientInfo, ConsentStatus.OPTED_OUT, input);
    }
    async updateIASConsent(consentingPatientInfo, consentStatus, input) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
        const canUpdateIASConsent = this.authManager.userType === "PATIENT";
        if (!canUpdateIASConsent)
            return;
        const update = new ConsentUpdateFromUI({
            consentUIFlow: (_a = input.consentUIFlow) !== null && _a !== void 0 ? _a : null,
            uiHash: (_b = input.uiHash) !== null && _b !== void 0 ? _b : null,
            consentDataResourceScopes: (_c = input.consentDataResourceScopes) !== null && _c !== void 0 ? _c : null,
            consentDataSensitivityScopes: (_d = input.consentDataSensitivityScopes) !== null && _d !== void 0 ? _d : null,
            expirationDate: (_e = input.expirationDate) !== null && _e !== void 0 ? _e : undefined,
            patientName: (_f = input.patientName) !== null && _f !== void 0 ? _f : null,
            signerName: (_g = input.signerName) !== null && _g !== void 0 ? _g : null,
            signingReason: (_h = input.signingReason) !== null && _h !== void 0 ? _h : null,
            revocationReason: (_j = input.revocationReason) !== null && _j !== void 0 ? _j : null,
            pagesViewed: (_k = input.pagesViewed) !== null && _k !== void 0 ? _k : null,
            mp4Url: (_l = input.mp4Url) !== null && _l !== void 0 ? _l : null,
            posterUrl: (_m = input.posterUrl) !== null && _m !== void 0 ? _m : null,
            consentedByLink: (_o = input.consentedByLink) !== null && _o !== void 0 ? _o : null,
            providerId: (_p = input.providerId) !== null && _p !== void 0 ? _p : null,
            providerSignerName: (_q = input.providerSignerName) !== null && _q !== void 0 ? _q : null,
            providerSigningReason: (_r = input.providerSigningReason) !== null && _r !== void 0 ? _r : null,
            parentGuardianSignerName: (_s = input.parentGuardianSignerName) !== null && _s !== void 0 ? _s : null,
            parentGuardianSigningReason: (_t = input.parentGuardianSigningReason) !== null && _t !== void 0 ? _t : null,
            additionalParentGuardianSignerName: (_u = input.additionalParentGuardianSignerName) !== null && _u !== void 0 ? _u : null,
            additionalParentGuardianSigningReason: (_v = input.additionalParentGuardianSigningReason) !== null && _v !== void 0 ? _v : null,
            additionalParentGuardianExemptSignature: (_w = input.additionalParentGuardianExemptSignature) !== null && _w !== void 0 ? _w : null,
            minorParticipantSignerName: (_x = input.minorParticipantSignerName) !== null && _x !== void 0 ? _x : null,
            minorParticipantExemptFromAssent: (_y = input.minorParticipantExemptFromAssent) !== null && _y !== void 0 ? _y : null,
            patientMRN: (_z = input.patientMRN) !== null && _z !== void 0 ? _z : null,
            larSignerName: (_0 = input.larSignerName) !== null && _0 !== void 0 ? _0 : null,
            larSigningReason: (_1 = input.larSigningReason) !== null && _1 !== void 0 ? _1 : null,
            larParticipantSignerName: (_2 = input.larParticipantSignerName) !== null && _2 !== void 0 ? _2 : null,
            larParticipantExemptSignature: (_3 = input.larParticipantExemptSignature) !== null && _3 !== void 0 ? _3 : null,
            larParticipantSigningReason: (_4 = input.larParticipantSigningReason) !== null && _4 !== void 0 ? _4 : null,
            witnessSkipSignature: (_5 = input.witnessSkipSignature) !== null && _5 !== void 0 ? _5 : null,
            witnessSignerName: (_6 = input.witnessSignerName) !== null && _6 !== void 0 ? _6 : null,
            isProxyAccess: (_7 = input.isProxyAccess) !== null && _7 !== void 0 ? _7 : null,
            fullRecordWithoutRestrictedData: null,
            documentRetrievalLocations: (_8 = input.documentRetrievalLocations) !== null && _8 !== void 0 ? _8 : [],
            loggedInDuringConsent: (_9 = input.loggedInDuringConsent) !== null && _9 !== void 0 ? _9 : null,
            retrieval: (_10 = input.retrieval) !== null && _10 !== void 0 ? _10 : null,
            locationsNeedingAuthentication: (_11 = input.locationsNeedingAuthentication) !== null && _11 !== void 0 ? _11 : [],
        });
        this.submittingConsent = true;
        const consentTypes = getIASConsentTypes();
        try {
            for (const consentType of consentTypes) {
                await this.patientService.updateIASConsent(consentingPatientInfo.id, consentType, new ConsentUpdate({
                    patientState: consentingPatientInfo.state,
                    consentStatus,
                    ...update,
                }));
            }
        }
        finally {
            this.submittingConsent = false;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], IASManager.prototype, "submittingConsent", void 0);
